/**
 * Performs an action after a delay if a check passes at time of execution after delay
 * @param delay in milliseconds
 * @param checkFn arrow function that is evaluated at time of execution after delay
 * @param actionFn arrow function that is executed after delay if checkFn returns true
 */
export default function performActionAfterDelayIfCheckPasses(delay, checkFn, actionFn) {
    setTimeout(() => {
        if (checkFn())
            actionFn();
    }, delay);
}
